require('es6-promise').polyfill();
require('isomorphic-fetch');

export default (url: string, body: string, headers?: Headers) => {
  const CARBON_BASE_URL = process?.env?.CARBON_BASE_URL ?? '';
  const DefaultHeaders = new Headers();

  if (headers === undefined) {
    DefaultHeaders.append(
      'Authorization',
      Buffer.from(process.env['ALL_PERMS_CREDS'] ?? '').toString('base64')
    );
    DefaultHeaders.append('Content-Type', 'application/json');
  } else {
    headers.append('Content-Type', 'application/json');
  }

  return fetch(`${window ? '' : CARBON_BASE_URL}${url}`, {
    body,
    method: 'DELETE',
    headers: headers ?? DefaultHeaders,
  });
};
